import * as React from 'react'
import { useCallback, useEffect, useReducer, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import Card from '../card/Card'
import CardHeader from '../card/CardHeader'
import CardBody from '../card/CardBody'
import CustomInput from '../input/CustomInput'
import CardFooter from '../card/CardFooter'
import Button from '../button/RegularButton'
import { timeout } from '../../App'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import styles from '../../assets/jss/dorm-app/customSelectStyle.js'
import { useParams } from 'react-router-dom'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

function engagementReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'create':
      return {
        ...state,
      }
    case 'fetch':
      return {
        ...action.value,
      }
    case 'success':
      return {
        success: true,
        ...initialEngagementState,
      }

    case 'error':
      return {
        errorMessage: action.errorMessage,
        ...initialEngagementState,
      }

    default:
      break
  }
  return state
}

const initialEngagementState = {
  success: false,
  errorMessage: '',
  department: '',
  semester: '',
  tenantName: '',
  tenantEmail: '',
  tenantRoom: '',
  points: '',
  note: '',
  engagementId: '',
}

export default function EditEngagement() {
  const classes = useStyles()

  const { engagementId } = useParams()

  const [state, dispatch] = useReducer(engagementReducer, initialEngagementState)
  const [proceeding, setProceeding] = useState(true)

  const [notification, setNotification] = useState(initialNotificationState)

  const fetchEngagement = useCallback(() => {
    getApiUrl()
      .get(`/api/engagements/${engagementId}`)
      .then(function(response) {
        setProceeding(false)
        dispatch({ type: 'fetch', value: response.data })
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [engagementId])

  useEffect(() => {
    setProceeding(true)
    fetchEngagement()
  }, [fetchEngagement])

  const submitForm = (e) => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }

    e.preventDefault()

    dispatch({ type: 'create' })

    getApiUrl()
      .put(`/api/engagements/${engagementId}`, state)
      .then(function() {
        fetchEngagement()
        setNotification({
          open: true,
          message: 'Erfolgreich aktualisiert',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Amt bearbeiten</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Referat"
                    id="department"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.department,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'department',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Semester"
                    id="semester"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.semester,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'semester',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Email"
                    id="tenantEmail"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.tenantEmail,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'tenantEmail',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Name"
                    id="tenantName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.tenantName,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'tenantName',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Zimmer"
                    id="tenantRoom"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: state.tenantRoom,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'tenantRoom',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Punkte"
                    id="points"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: state.points,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'points',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Notiz (optional)"
                    id="note"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: state.note,
                      type: 'text',
                      onChange: (e) =>
                        dispatch({
                          type: 'field',
                          field: 'note',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button
                color="primary"
                onClick={(e) => {
                  submitForm(e)
                }}>
                Daten aktualisieren
              </Button>
            </CardFooter>
          </Card>
          <Snackbar
            place="br"
            color={notification.color}
            icon={AddAlert}
            message={notification.message}
            open={notification.open}
            closeNotification={() =>
              setNotification({
                open: false,
                message: '',
                color: '',
              })
            }
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  )
}
